import { render, staticRenderFns } from "./CpuInfo.vue?vue&type=template&id=00aa7d8d&"
import script from "./CpuInfo.vue?vue&type=script&lang=js&"
export * from "./CpuInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports